import { IDirective } from 'angular';
import { GmcDatePickerController } from './gmc-date-picker.component';

export function gmcDatePickerBtnDirective(): IDirective {
  return {
    restrict: 'A',
    require: '^gmcDatePicker',
    link: function postLink( scope, element, attrs, datePicker: GmcDatePickerController ) {
      element.on('click', ( event ) => {
        event.preventDefault();
        if ( datePicker.inputElement ) {
          datePicker.inputElement.trigger('click');
        }
      });
    }
  };
}

gmcDatePickerBtnDirective.$inject = [];



// WEBPACK FOOTER //
// ./app/shared/components/gmc-date-picker/gmc-date-picker-btn.directive.ts